import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from 'axios'
import ServerError from './layout/500'
import PageLoader from './components/PageLoader'
import ImageLoader from './components/ImageLoader'
import VueElementLoading from 'vue-element-loading'
import VideoBg from 'vue-videobg'

Vue.component('video-bg', VideoBg)

import VideoBackground from 'vue-responsive-video-background-player'

 Vue.component('video-background', VideoBackground);

Vue.component('VueElementLoading', VueElementLoading)
Vue.component('ServerError', ServerError)
Vue.component('PageLoader', PageLoader)
Vue.component('ImageLoader', ImageLoader)

Vue.config.productionTip = false

axios.defaults.baseURL = 'https://api.tigerthon.com/';
Vue.prototype.baseURL = "https://api.tigerthon.com/"
Vue.prototype.mediaURL = "https://api.tigerthon.com/"

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
